
import { defineComponent, SetupContext, PropType, ref, computed, ComponentPublicInstance, onMounted } from "vue";
import { FridgeDetailsDoorOpenInfoWeeklyItem, FridgeDetailsDoorMonitorWeeklyArrayData } from "@/types/fridgeDetails"
import NativeClient from "@/client/native-client";
import { translateYYYYMMDDToYYYYMDJapan } from "@/utils/common-utils";
import FridgeDoorMonitorWeeklyItem from "@/components/fridgeDetails/FridgeDoorMonitorWeeklyItem.vue";

export default defineComponent({
  name: "FridgeDoorMonitorWeekly",
  components: { FridgeDoorMonitorWeeklyItem },
  props: {
    /** ドア開閉情報 */
    list: {
      type: Array as PropType<FridgeDetailsDoorOpenInfoWeeklyItem[]>,
      default: []
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDoorMonitorWeekly setup start");
    NativeClient.sendDebugLog("FridgeDoorMonitorWeekly list = " + JSON.stringify(props.list));
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 選択中の位置
    const selectIndex = ref(0);

    // 日付
    const datesRangeString = computed(() => {
      let datesRangeString = "";
      if (props.list.length > 1) {
        NativeClient.sendDebugLog("FridgeDoorMonitorWeekly dateList list.length > 1");
        const dateStringFirst = translateYYYYMMDDToYYYYMDJapan(props.list[0].date);
        const dateStringLast = translateYYYYMMDDToYYYYMDJapan(props.list[props.list.length - 1].date);
        datesRangeString = dateStringFirst + "〜" + dateStringLast;
      }
      return datesRangeString;
    });

    // 一週間分のデータ
    const weeklyList = computed(() => {
      const weeklyList: Array<FridgeDetailsDoorMonitorWeeklyArrayData> = [];
      const element = new FridgeDetailsDoorMonitorWeeklyArrayData();
      element.list = props.list
      weeklyList.push(element);
      NativeClient.sendDebugLog("FridgeDoorMonitorWeekly weeklyList = " + JSON.stringify(weeklyList));
      return weeklyList;
    });

    // スクロール
    const scroll = ref<ComponentPublicInstance<HTMLInputElement>>();

    onMounted(() => {
      NativeClient.sendDebugLog("FridgeDoorMonitorWeekly onMounted");
      updateDisplay();
    });

    // ボタン押下
    const clickCaution = () => {
      NativeClient.sendDebugLog("FridgeDoorMonitorWeekly clickCaution");
      context.emit("click-dooralarm");
    };

    return {
      selectIndex,
      datesRangeString,
      weeklyList,
      scroll,
      updateDisplayKey,
      clickCaution
    };
  }
});
